var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row mcard-header"},[_c('div',{staticClass:"col title"},[(_vm.icon)?_c('i',{class:`fas ${_vm.icon}`}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"col slot-section"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }